import axios from 'axios'
import baseUrl from './base-url'
import { getValidUrl } from '../util'

export default function({ state }, { url, data, query }) {
    if (query)
        url = url + '?' + Object.keys(query).map((q) => (q + '=' + query[q])).join('&')

    url = getValidUrl(url, state)

    return axios.patch(baseUrl + url, data || {}, {
            withCredentials: true
        })
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            throw error.response.data
        })
}
